export const AUTH_SESSION_LOADING_TIMEOUT_MS = 3_000;
export const AUTH_OAUTH_SESSION_LOADING_TIMEOUT_MS = 5_000;

export function authSessionLoadingTimeoutMs(hasOauthUrlParams: boolean): number {
  return hasOauthUrlParams
    ? AUTH_OAUTH_SESSION_LOADING_TIMEOUT_MS
    : AUTH_SESSION_LOADING_TIMEOUT_MS;
}
